import {useEffect, useState} from "react";
import InstrumentIcon from "../../../components/instrument-icon";
import {useSelector} from "react-redux";
import store from "../../../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../../../actions/authentication-actions";
import {useTranslation} from "react-i18next";
import SvgIcon from "../../../components/svg-icon";

const currencies = ["EUR", "USD", "BRL", "CAD", "CLP", "CNY", "DKK", "IDR", "INR", "JPY", "KRW", "MXN", "PHP", "PLN", "RUB", "TRY", "VND"]
const WalletSettings = (props) => {

    const {
        hideZeroBalances,
        displayCryptoInFiat,
        selectedFiat
    } = useSelector(state => state.authenticationReducer)
    const {authenticated} = useSelector(state => state.authenticationReducer)

    const [localeSelectedFiat, setLocaleSelectedFiat] = useState(null)
    const [localDisplayCryptoInFiat, setLocalDisplayCryptoInFiat] = useState(false)
    const [localeHideZero, setLocaleHideZero] = useState('')

    useEffect(() => {
        setLocaleSelectedFiat(selectedFiat)
    }, [selectedFiat])

    useEffect(() => {
        setLocalDisplayCryptoInFiat(displayCryptoInFiat)
    }, [displayCryptoInFiat])

    useEffect(() => {
        setLocaleHideZero(hideZeroBalances)
    }, [hideZeroBalances])
    const {handleClose} = props
    const {t} = useTranslation()

    useEffect(() => {
        if (authenticated) {
            const bdy = document.body
            bdy.classList?.add('modal-open')

            const mdl = document.getElementById('wallet-settings-modal')
            mdl.classList?.add('show')

            mdl.style.display = 'block'
            mdl.style.backgroundColor = 'rgba(0,0,0,.7)'


            return () => {
                bdy.classList?.remove('modal-open')
                mdl.classList?.remove('show')

            }
        }
    }, [authenticated])


    // const handleSetHideZeroBalances = () => store.dispatch(AUTHENTICATION_ACTIONS.setHideZeroBalancesAction(!hideZeroBalances))
    // const handleSetDisplayCryptoFiat = () => {
    //     if (displayCryptoInFiat) {
    //         setLocaleSelectedFiat('')
    //     }
    //
    //     store.dispatch(AUTHENTICATION_ACTIONS.setDisplayFiatInCryptoAction(!displayCryptoInFiat))
    // }
    const handleSetSelectedFiat = fiat => {
        if (!localDisplayCryptoInFiat)
            return false;

        setLocaleSelectedFiat(fiat)
    }

    const handleSave = () => {
        store.dispatch(AUTHENTICATION_ACTIONS.setSelectedFiatAction(localeSelectedFiat))

        store.dispatch(AUTHENTICATION_ACTIONS.setHideZeroBalancesAction(localeHideZero))
        store.dispatch(AUTHENTICATION_ACTIONS.setDisplayFiatInCryptoAction(localDisplayCryptoInFiat))

        handleClose()
    }

    return (
        <div
            className="modal fade"
            id="wallet-settings-modal"
            tabIndex={-1}
            onClick={handleClose}
        >
            <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal__content">
                        <div className="modal__head">
                            <h6 className="modal__title">
                                {t('wallet-settings.title')}
                            </h6>
                            <button
                                className="modal__close"
                                type="button"
                                onClick={handleClose}
                            >
                                <SvgIcon id={'x'}/>
                            </button>
                        </div>
                        <div className="modal__form">
                            <div onClick={e => setLocaleHideZero(!localeHideZero)} className="form__switch">
                                <input
                                    disabled={true}
                                    type="checkbox"
                                    className="form__switch-input"
                                    name="switch01"
                                    id="switch01"
                                    checked={localeHideZero || false}
                                />
                                <label htmlFor="switch01">
                                    <p>
                                        {t('wallet-settings.hide-zero-balances')}
                                    </p>
                                    <span>
                                         {t('wallet-settings.hide-zero-balances-desc')}
                                    </span>
                                </label>
                            </div>

                            <div className="form__switch"
                                 onClick={e => {
                                     if (localDisplayCryptoInFiat)
                                         setLocaleSelectedFiat(null)
                                     setLocalDisplayCryptoInFiat(!localDisplayCryptoInFiat)
                                 }}>
                                <input
                                    disabled
                                    checked={localDisplayCryptoInFiat}
                                    type="checkbox"
                                    className="form__switch-input"
                                    name="switch02"
                                    id="switch02"
                                />
                                <label htmlFor="switch02">
                                    <p>
                                        {t('wallet-settings.display-crypto-in-fiat')}
                                    </p>
                                    <span>
                                        {t('wallet-settings.display-crypto-in-fiat-desc')}
                                  </span>
                                </label>
                            </div>
                            <div className="form__group">
                                <div className="form__radio">
                                    <ul className="row">

                                        {
                                            currencies?.map(currency => (
                                                <li
                                                    key={currency}
                                                    onClick={e => handleSetSelectedFiat(currency)}
                                                    className={`fiat-item col-4 ${!localDisplayCryptoInFiat ? 'disactive' : ''}`}>
                                                    <input
                                                        disabled
                                                        id="fiat1"
                                                        type="checkbox"
                                                        name="fiat1"
                                                        checked={localeSelectedFiat === currency}
                                                    />
                                                    <label htmlFor="fiat1">
                                                        {currency}
                                                        <InstrumentIcon code={currency}/>
                                                    </label>
                                                </li>
                                            ))
                                        }


                                    </ul>
                                </div>
                            </div>

                            <button
                                onClick={handleSave}
                                disabled={hideZeroBalances === localeHideZero && localeSelectedFiat === selectedFiat}
                                className="form__btn" type="button">
                                {t('general.save')}
                            </button>


                            <div className="form__text">
                                <p>
                                    {t('wallet-settings.footer')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}


export default WalletSettings
